import config from "../../config/config";
import axios from "axios";
import { getToken } from "../../common";

export const fetchAPIEndpointsListAPI = async () => {
  return await axios({
    method: "get",
    url: `${config.api.base_url}api-keys/endpoints`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default fetchAPIEndpointsListAPI;
